<template>
  <div class="avue-logo">
    <transition name="fade">
      <img v-if="keyCollapse"
           class="avue-logo_subtitle"
           key="0"
           @error="setDefaultImg"
           :src="logoSrc"
           alt=""
           width="40"
           height="32" />
    </transition>
    <transition-group name="fade">
      <template v-if="!keyCollapse">
        <span class="avue-logo_title"
              @click="toHome"
              key="1">
          <img class="logo-img"
               :src="logoSrc"
               alt=""
               @error="setDefaultImg"
               width="40"
               height="32" />
          <span class="logo-title">
            宁国运中卫公铁物流园
          </span>
        </span>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'logo',
  data() {
    return {
      logoSrc: `${process.env.BASE_URL}logo.png`,
    }
  },
  created() { },
  computed: {
    ...mapGetters(['website', 'keyCollapse']),
  },
  methods: {
    toHome() {
      this.$router.push('/wel/index')
    },
    setDefaultImg(e) {
      e.target.style = 'display:none'
      // e.target.src = require('../../../public/img/logo.png')
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-active {
  transition: opacity 2.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.avue-logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 256px;
  height: 64px;
  // line-height: 64px;
  background-color: #20222a;
  font-size: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.8);
  z-index: 1024;
  &_title {
    display: block;
    text-align: center;
    font-weight: 300;
    font-size: 20px;
  }
  &_subtitle {
    display: block;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }

  .avue-logo_title {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    .logo-img {
      vertical-align: bottom;
      flex: 0 0 auto;
      margin: 0 6px 0 0;
    }

    img[src=''],
    img:not([src]) {
      // opacity: 0;
      display: none;
    }

    .logo-title {
      display: block;
      max-width: 190px;
      overflow: hidden;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      line-height: 20px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.avue-logo_subtitle {
  margin-top: 13px;
  margin-left: 7px;
}
</style>
